module.exports = __webpack_public_path__ + "static/yt_2@2x-efa011da2f90c1460d80bd87246f6456.jpg";